import { render, staticRenderFns } from "./WipFileAttachments.vue?vue&type=template&id=3587183a&scoped=true&"
import script from "./WipFileAttachments.vue?vue&type=script&lang=ts&"
export * from "./WipFileAttachments.vue?vue&type=script&lang=ts&"
import style0 from "./WipFileAttachments.vue?vue&type=style&index=0&id=3587183a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3587183a",
  null
  
)

export default component.exports